/* Ryan Locale Modal Data (Shopify theme adaptation - no ES modules) */
(function() {
/**
 * Data for the Ryan locale (country / currency) + language pop-up.
 *
 * Notes:
 * - COUNTRY_CURRENCY is generated from CLDR territory currency data (via Babel).
 * - Country names are resolved at runtime using Intl.DisplayNames so they can change
 *   with the user's selected language.
 */

const SUPPORTED_LANGUAGES = [
  {
    "code": "en",
    "label": "ENGLISH"
  },
  {
    "code": "es",
    "label": "ESPAÑOL"
  },
  {
    "code": "it",
    "label": "ITALIANO"
  },
  {
    "code": "nl",
    "label": "NEDERLANDS"
  },
  {
    "code": "fr",
    "label": "FRANÇAIS"
  },
  {
    "code": "de",
    "label": "DEUTSCH"
  }
];

const TRANSLATIONS = {
  "en": {
    "shoppingFrom": "YOU ARE SHOPPING FROM",
    "bullets": [
      "Free shipping on orders over $150.",
      "Easy returns within 14 days from reception.",
      "The total amount you pay includes all applicable customs.<br/>We guarantee no additional charges on delivery.",
      "Card, PayPal, Klarna & other local payment methods."
    ],
    "confirm": "CONFIRM"
  },
  "es": {
    "shoppingFrom": "ESTÁS COMPRANDO DESDE",
    "bullets": [
      "Envío gratis en pedidos superiores a $150.",
      "Devoluciones fáciles dentro de 14 días desde la recepción.",
      "El total que pagas incluye todos los aranceles aplicables.<br/>Garantizamos que no habrá cargos adicionales en la entrega.",
      "Tarjeta, PayPal, Klarna y otros métodos de pago locales."
    ],
    "confirm": "CONFIRMAR"
  },
  "it": {
    "shoppingFrom": "STAI ACQUISTANDO DA",
    "bullets": [
      "Spedizione gratuita per ordini superiori a $150.",
      "Resi facili entro 14 giorni dalla ricezione.",
      "L'importo totale include tutti i dazi doganali applicabili.<br/>Garantiamo nessun costo aggiuntivo alla consegna.",
      "Carta, PayPal, Klarna e altri metodi di pagamento locali."
    ],
    "confirm": "CONFERMA"
  },
  "nl": {
    "shoppingFrom": "JE WINKELT VANUIT",
    "bullets": [
      "Gratis verzending op bestellingen boven $150.",
      "Eenvoudig retourneren binnen 14 dagen na ontvangst.",
      "Het totaalbedrag dat je betaalt is inclusief alle toepasselijke invoerrechten.<br/>Wij garanderen geen extra kosten bij levering.",
      "Kaart, PayPal, Klarna en andere lokale betaalmethoden."
    ],
    "confirm": "BEVESTIGEN"
  },
  "fr": {
    "shoppingFrom": "VOUS ACHETEZ DEPUIS",
    "bullets": [
      "Livraison offerte pour les commandes supérieures à $150.",
      "Retours faciles sous 14 jours après réception.",
      "Le montant total inclut tous les droits de douane applicables.<br/>Nous garantissons aucun frais supplémentaire à la livraison.",
      "Carte, PayPal, Klarna et autres moyens de paiement locaux."
    ],
    "confirm": "CONFIRMER"
  },
  "de": {
    "shoppingFrom": "SIE KAUFEN AUS",
    "bullets": [
      "Kostenloser Versand für Bestellungen über $150.",
      "Einfache Rückgabe innerhalb von 14 Tagen nach Erhalt.",
      "Der Gesamtbetrag beinhaltet alle anfallenden Zollgebühren.<br/>Wir garantieren keine zusätzlichen Kosten bei Lieferung.",
      "Karte, PayPal, Klarna & andere lokale Zahlungsmethoden."
    ],
    "confirm": "BESTÄTIGEN"
  }
};

const COUNTRY_CURRENCY = {
  "AD": "EUR",
  "AE": "AED",
  "AF": "AFN",
  "AG": "XCD",
  "AI": "XCD",
  "AL": "ALL",
  "AM": "AMD",
  "AO": "AOA",
  "AQ": "XXX",
  "AR": "ARS",
  "AS": "USD",
  "AT": "EUR",
  "AU": "AUD",
  "AW": "AWG",
  "AX": "EUR",
  "AZ": "AZN",
  "BA": "BAM",
  "BB": "BBD",
  "BD": "BDT",
  "BE": "EUR",
  "BF": "XOF",
  "BG": "BGN",
  "BH": "BHD",
  "BI": "BIF",
  "BJ": "XOF",
  "BL": "EUR",
  "BM": "BMD",
  "BN": "BND",
  "BO": "BOB",
  "BQ": "USD",
  "BR": "BRL",
  "BS": "BSD",
  "BT": "BTN",
  "BV": "NOK",
  "BW": "BWP",
  "BY": "BYN",
  "BZ": "BZD",
  "CA": "CAD",
  "CC": "AUD",
  "CD": "CDF",
  "CF": "XAF",
  "CG": "XAF",
  "CH": "CHF",
  "CI": "XOF",
  "CK": "NZD",
  "CL": "CLP",
  "CM": "XAF",
  "CN": "CNY",
  "CO": "COP",
  "CR": "CRC",
  "CU": "CUP",
  "CV": "CVE",
  "CW": "XCG",
  "CX": "AUD",
  "CY": "EUR",
  "CZ": "CZK",
  "DE": "EUR",
  "DJ": "DJF",
  "DK": "DKK",
  "DM": "XCD",
  "DO": "DOP",
  "DZ": "DZD",
  "EC": "USD",
  "EE": "EUR",
  "EG": "EGP",
  "EH": "MAD",
  "ER": "ERN",
  "ES": "EUR",
  "ET": "ETB",
  "FI": "EUR",
  "FJ": "FJD",
  "FK": "FKP",
  "FM": "USD",
  "FO": "DKK",
  "FR": "EUR",
  "GA": "XAF",
  "GB": "GBP",
  "GD": "XCD",
  "GE": "GEL",
  "GF": "EUR",
  "GG": "GBP",
  "GH": "GHS",
  "GI": "GIP",
  "GL": "DKK",
  "GM": "GMD",
  "GN": "GNF",
  "GP": "EUR",
  "GQ": "XAF",
  "GR": "EUR",
  "GS": "GBP",
  "GT": "GTQ",
  "GU": "USD",
  "GW": "XOF",
  "GY": "GYD",
  "HK": "HKD",
  "HM": "AUD",
  "HN": "HNL",
  "HR": "EUR",
  "HT": "USD",
  "HU": "HUF",
  "ID": "IDR",
  "IE": "EUR",
  "IL": "ILS",
  "IM": "GBP",
  "IN": "INR",
  "IO": "USD",
  "IQ": "IQD",
  "IR": "IRR",
  "IS": "ISK",
  "IT": "EUR",
  "JE": "GBP",
  "JM": "JMD",
  "JO": "JOD",
  "JP": "JPY",
  "KE": "KES",
  "KG": "KGS",
  "KH": "KHR",
  "KI": "AUD",
  "KM": "KMF",
  "KN": "XCD",
  "KP": "KPW",
  "KR": "KRW",
  "KW": "KWD",
  "KY": "KYD",
  "KZ": "KZT",
  "LA": "LAK",
  "LB": "LBP",
  "LC": "XCD",
  "LI": "CHF",
  "LK": "LKR",
  "LR": "LRD",
  "LS": "LSL",
  "LT": "EUR",
  "LU": "EUR",
  "LV": "EUR",
  "LY": "LYD",
  "MA": "MAD",
  "MC": "EUR",
  "MD": "MDL",
  "ME": "EUR",
  "MF": "EUR",
  "MG": "MGA",
  "MH": "USD",
  "MK": "MKD",
  "ML": "XOF",
  "MM": "MMK",
  "MN": "MNT",
  "MO": "MOP",
  "MP": "USD",
  "MQ": "EUR",
  "MR": "MRU",
  "MS": "XCD",
  "MT": "EUR",
  "MU": "MUR",
  "MV": "MVR",
  "MW": "MWK",
  "MX": "MXN",
  "MY": "MYR",
  "MZ": "MZN",
  "NA": "NAD",
  "NC": "XPF",
  "NE": "XOF",
  "NF": "AUD",
  "NG": "NGN",
  "NI": "NIO",
  "NL": "EUR",
  "NO": "NOK",
  "NP": "NPR",
  "NR": "AUD",
  "NU": "NZD",
  "NZ": "NZD",
  "OM": "OMR",
  "PA": "USD",
  "PE": "PEN",
  "PF": "XPF",
  "PG": "PGK",
  "PH": "PHP",
  "PK": "PKR",
  "PL": "PLN",
  "PM": "EUR",
  "PN": "NZD",
  "PR": "USD",
  "PS": "JOD",
  "PT": "EUR",
  "PW": "USD",
  "PY": "PYG",
  "QA": "QAR",
  "RE": "EUR",
  "RO": "RON",
  "RS": "RSD",
  "RU": "RUB",
  "RW": "RWF",
  "SA": "SAR",
  "SB": "SBD",
  "SC": "SCR",
  "SD": "SDG",
  "SE": "SEK",
  "SG": "SGD",
  "SH": "SHP",
  "SI": "EUR",
  "SJ": "NOK",
  "SK": "EUR",
  "SL": "SLE",
  "SM": "EUR",
  "SN": "XOF",
  "SO": "SOS",
  "SR": "SRD",
  "SS": "SSP",
  "ST": "STN",
  "SV": "USD",
  "SX": "XCG",
  "SY": "SYP",
  "SZ": "SZL",
  "TC": "USD",
  "TD": "XAF",
  "TF": "EUR",
  "TG": "XOF",
  "TH": "THB",
  "TJ": "TJS",
  "TK": "NZD",
  "TL": "USD",
  "TM": "TMT",
  "TN": "TND",
  "TO": "TOP",
  "TR": "TRY",
  "TT": "TTD",
  "TV": "AUD",
  "TW": "TWD",
  "TZ": "TZS",
  "UA": "UAH",
  "UG": "UGX",
  "UM": "USD",
  "US": "USD",
  "UY": "UYU",
  "UZ": "UZS",
  "VA": "EUR",
  "VC": "XCD",
  "VE": "VES",
  "VG": "USD",
  "VI": "USD",
  "VN": "VND",
  "VU": "VUV",
  "WF": "XPF",
  "WS": "WST",
  "YE": "YER",
  "YT": "EUR",
  "ZA": "ZAR",
  "ZM": "ZMW",
  "ZW": "ZWG"
};


  // Expose for ryan-locale-modal.js
  window.RY_LOCALE_DATA = window.RY_LOCALE_DATA || {};
  window.RY_LOCALE_DATA.SUPPORTED_LANGUAGES = SUPPORTED_LANGUAGES;
  window.RY_LOCALE_DATA.TRANSLATIONS = TRANSLATIONS;
  window.RY_LOCALE_DATA.COUNTRY_CURRENCY = COUNTRY_CURRENCY;
})();
